var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AchooPieChartComponent } from '../../../../core/achoo-pie-chart/achoo-pie-chart.component';
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { chartConfig, GenderEnum } from '../../../../app.constants';
import { DeviceDetectorService } from 'ngx-device-detector';
import { InfluencerDemographicGender } from '../../influencer-demographics/influencer-demographics.component';
var DemographicGenderChartComponent = /** @class */ (function (_super) {
    __extends(DemographicGenderChartComponent, _super);
    function DemographicGenderChartComponent(pdfService, userService, translate, deviceService) {
        var _this = _super.call(this, pdfService, userService, translate, deviceService) || this;
        _this.pdfService = pdfService;
        _this.userService = userService;
        _this.translate = translate;
        _this.deviceService = deviceService;
        _this.femaleColor = userService.chartColors[GenderEnum.FEMALE];
        _this.maleColor = userService.chartColors[GenderEnum.MALE];
        return _this;
    }
    DemographicGenderChartComponent.prototype.ngOnInit = function () {
        this.options = {
            chart: {
                height: this.height,
                type: chartConfig.type.pie,
                margin: [0, 0, 0, 0],
                spacingTop: 0,
                spacingBottom: 0,
                spacingLeft: 0,
                spacingRight: 0,
                style: {
                    fontFamily: chartConfig.font.light
                },
            },
            colors: this.userService.chartColors,
            tooltip: {
                enabled: false
            },
            plotOptions: {
                pie: {
                    size: '100%',
                    height: '100%',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: false
                },
                series: {
                    animation: !this.pdfService.exportingPdf
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            series: [{
                    data: this.normalizeChartData(this.chartData),
                    size: this.pieSize || chartConfig.pieChart.size,
                    innerSize: this.pieInnerSize || chartConfig.pieChart.innerSize
                }]
        };
    };
    DemographicGenderChartComponent.prototype.saveInstance = function (chartInstance) {
        this.chart = chartInstance;
    };
    DemographicGenderChartComponent.prototype.showHideLegend = function () {
        if (!this.chart) {
            return;
        }
        this.chart.series[0].points[1].onMouseOver();
    };
    DemographicGenderChartComponent.prototype.genderPercent = function (gender) {
        if (!this.chartData) {
            return null;
        }
        var femaleData = this.chartData.find(function (c) { return c.name.toLowerCase() === gender; });
        return femaleData ? femaleData.y * 100 : null;
    };
    DemographicGenderChartComponent.prototype.clickLegend = function (legend) {
        if (!this.chart) {
            return;
        }
        this.chart.series[0].points.forEach(function (p) {
            if (p.name.toLowerCase() === legend) {
                var isVisible = p.visible;
                var updatedPoint = Object.assign({}, p, {
                    visible: !isVisible
                });
                p.update(updatedPoint);
            }
        });
    };
    DemographicGenderChartComponent.prototype.hoverLegend = function (legend) {
        if (!this.chart) {
            return;
        }
        this.chart.series[0].points.forEach(function (p) {
            if (p.name.toLowerCase() === legend) {
                p.onMouseOver();
            }
        });
    };
    DemographicGenderChartComponent.prototype.isVisibleLegend = function (legend) {
        if (!this.chart) {
            return false;
        }
        var activePoint = this.chart.series[0].points.find(function (p) { return p.name.toLowerCase() === legend; });
        return activePoint && activePoint.visible;
    };
    DemographicGenderChartComponent.prototype.normalizeChartData = function (chartData) {
        var _this = this;
        if (!chartData) {
            return [];
        }
        var female = InfluencerDemographicGender.Female.toString().toLowerCase();
        return chartData.map(function (c) { return ({
            name: c.name,
            y: c.y,
            x: c.name.toLowerCase() === female ? GenderEnum.FEMALE : GenderEnum.MALE,
            color: c.name.toLowerCase() === female ? _this.femaleColor : _this.maleColor
        }); });
    };
    return DemographicGenderChartComponent;
}(AchooPieChartComponent));
export { DemographicGenderChartComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic/demographic-gender-chart/demographic-gender-chart.component.ts.pre-build-optimizer.js